import { render } from "./AgendamentoModal.vue?vue&type=template&id=379e75ca&scoped=true&ts=true"
import script from "./AgendamentoModal.vue?vue&type=script&lang=ts"
export * from "./AgendamentoModal.vue?vue&type=script&lang=ts"

import "./AgendamentoModal.vue?vue&type=style&index=0&id=379e75ca&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379e75ca"]])

export default __exports__